export default {
  documentTitle:
    "Hardware wallet -Your key's pal to guarantee Crypto assets | KeyPal",
  product: 'Product',
  learn: 'Learn',
  support: 'Support',
  others: 'Others',
  language: 'Language',
}
